import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DATE_FORMAT } from 'app/shared/constants/input.constants';
import { map } from 'rxjs/operators';

import { IPrescriptionRx } from 'app/shared/model/prescription-rx.model';
import AppConfigService from 'app/core/app-config.service';

type EntityResponseType = HttpResponse<IPrescriptionRx>;

@Injectable({ providedIn: 'root' })
export default class PrescriptionRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/prescriptions`;

  selectedPatient: any;

  constructor(protected http: HttpClient) {}

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IPrescriptionRx>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      res.body.lastFillDate = res.body.lastFillDate != null ? moment(res.body.lastFillDate) : null;
    }
    return res;
  }

  // NexGen custom functions starts here
  getPrescriptionList(page, patientId, orderBy, order, filterByStatus): Observable<any> {
    let url = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxrefillrequest/${patientId}?page=${page}&requestedBy=API-USER&size=15`;
    if (orderBy) {
      url += `&sortby=${orderBy}`;
    } else {
      url += '&sortby=';
    }

    if (order) {
      url += `&order=${order}`;
    } else {
      url += '&order=';
    }

    url += `&filter=${filterByStatus}`;

    return this.http.get(url);
  }

  getDependentList(peopleSoftId): Observable<any> {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/peoplesoft-imports/getDependents/${peopleSoftId}`);
  }

  public getPharmacyList() {
    const pharmacyListUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/pharmacy`;
    return this.http.get(pharmacyListUrl, { observe: 'response' });
  }

  checkRxRefillEligibility(rxDetails: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/prescriptions?page=1&size=10`, rxDetails);
  }

  resetSelectedPatient() {
    this.selectedPatient = false;
  }

  submitRefillRequest(rxData: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxRefillRequest`, rxData);
  }

  getRxProfileData(patientId) {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${patientId}`);
  }

  getCreditCardStatus(patientId) {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/isCreditcardOnFile/${patientId}?requestedBy=API-USER`);
  }

  subscribeForRefillReminder(rxData: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/refill/reminder/optIn`, rxData);
  }

  sendHiddenRxList(patientId, hideList: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxrefillrequest/${patientId}/filterRxList`, hideList);
  }
}
